import {
  type ToolbarModuleConfig,
  ToolbarModuleExtension,
} from '@blocksuite/affine-shared/services';
import { BlockFlavourIdentifier } from '@blocksuite/std';

import { StickyNoteBlockModel } from '../schemas/sticky-note-model.js';
import { createCanvasTextStyleActions } from '../text-style-toolbar.js';

const stickyNoteToolbarConfig = {
  actions: createCanvasTextStyleActions({
    getModels: ctx => ctx.getSurfaceModelsByType(StickyNoteBlockModel),
    fallbackColor: () => '#312d27',
  }),
  when: ctx => ctx.getSurfaceModelsByType(StickyNoteBlockModel).length > 0,
} as const satisfies ToolbarModuleConfig;

export const stickyNoteToolbarExtension = ToolbarModuleExtension({
  id: BlockFlavourIdentifier('affine:surface:sticky-note'),
  config: stickyNoteToolbarConfig,
});
